var objArchExport = {
    // <summary>
    // This object holds all export relevant functions
    // </summary>
    _initExportEvents: function (me) {
        /// <summary>
        /// This function initiates the events for the export
        /// </summary>
        try {
            
            me.vcMenu.menu.top.export.menu.off("click", ".button-toggle").on("click", ".button-toggle", function () { objArchExport._selectExportItem(me, this); });
            me.vcMenu.menu.top.export.btn.off("click").on("click", function () { objArchExport._exportNow(me); });

            me.exportPopup = $("<div>").addClass("vc-menu").attr("id", "popupExportDialog").css("overflow-y", "hidden").html(me.vcMenu.menu.top.export.wrapper).dialog({
                open: function () { objArchExport._initExport(me); },
                autoOpen: false, modal: true, width: me.settings.menu.top.export.width + 35, height: 800,
                resizable: false, dialogClass: "modal-popup-dialog", title: "", closeOnEscape: true, position: { my: 'top+10%', at: 'top', of: window },
                buttons: [{ text: window._RESOURCES.JS_Com.close_lbl, click: function () { me.exportPopup.dialog('close'); return true; } }]
            });

            me.vcMenu.menu.top.exportBtn.find("#btn-export-menu").off("click").on("click", function () { me.exportPopup.dialog("open"); });

            return true;
        }
        catch (e) { me._writeErr(e); return false; }
    },

    _initExport: function (me) {
        /// <summary>
        /// This function initiates the export dialog
        /// </summary>
        try {
            var menu = me.vcMenu.menu.top.export.menu.find(".file-export");

            //find the current chart for the export types
            var chart = me.settings.charts.filter(function (item) { return item.id == me.status.menu.selectedChart })[0];

            // check if icon chart is opened and overwrite current chart for the export types
            if (me.settings.currentIconChart.active) { chart = me.settings.currentIconChart.iconChart; }

            //validate if we find a valid highchart
            if (chart.exports.length > 0)
                menu.toggleClass("inactive", (typeof (window.__GLOBAL_VISUAL_LIST[me.globalVisualListKey]) == "undefined"));

            //show/hide exprot types
            $.each(menu, function () {
                var item = $(this);
                if (chart.exports.indexOf(item.data("type")) > -1) {
                    item.removeClass("inactive").show();
                } else {
                    item.addClass("inactive").hide();
                }
            });
            //validate the share menu
            me.vcMenu.menu.top.export.menu.find("#btn-share").toggleClass("inactive", me.status.signals.shareParameter == null);

            if (me.settings.currentIconChart.active) {
                me.vcMenu.menu.top.export.menu.find("#btn-share").toggleClass("inactive", true);
                me.vcMenu.menu.top.export.menu.find("#btn-favorites").toggleClass("inactive", true);
            }
            else
                me.vcMenu.menu.top.export.menu.find("#btn-favorites").toggleClass("inactive", false);


            //select the first active item
            objArchExport._selectExportItem(me, me.vcMenu.menu.top.export.menu.find(".button-toggle:not('.inactive')")[0]);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _selectExportItem: function (me, e) {
        /// <summary>
        /// This function fills the content for the given export type
        /// </summary>
        try {
            
            var item = $(e);
            me.vcMenu.menu.top.export.menu.find(".button-toggle").removeClass("button-toggle-active");
            item.addClass("button-toggle-active");


            let content = me.vcMenu.menu.top.export.content;
            content.html("").height(40);
            me.vcMenu.menu.top.export.btn.show();
            //add a warning for highcharts export server
            if (me.settings.menu.top.export.warnExternalExport) {
                switch (item.data("type")) {
                    case "csv": case "jpg": case "png": case "pdf":
                        let info = $("<div>").addClass("note vc-grid-margin-bottom").css("width", "95%").html(me.specific.resources.importantDataSentToExternalSystem + "<br/><br/>" + me.specific.resources.detailedInfosFindAt + "<br/>" + me.specific.resources.highchartsExportServerToU);
                        content.append(info).height(140);
                        break;
                }
            }

            switch (item.data("type")) {
                case "xls": content.html(me.specific.resources.dataExportAsFile.replace("{0}", "XLS")); break;
                case "csv": content.append(me.specific.resources.dataExportAsFile.replace("{0}", "CSV")); break;
                case "jpg": content.append(me.specific.resources.dataExportAsFile.replace("{0}", "JPG")); break;
                case "png": content.append(me.specific.resources.dataExportAsFile.replace("{0}", "PNG")); break;
                case "pdf": content.append(me.specific.resources.dataExportAsFile.replace("{0}", "PDF")); break;

                case "favorites":
                    content.html("").height(640);
                    me.vcMenu.menu.top.export.btn.hide();
                    me.vcV.addVisualContentByName('m-export-co', "VISUAL_FAVORITES_ARCHIVE", "ntent", window.getCurrentTimestamp(), me.settings.menu.top.export.width + 25, 650, JSON.stringify({ 'LoggerId': me.specific.LoggerId }), "", me.settings.deviceType);
                    break;

                case "share":
                    content.html("").height(640);
                    me.vcMenu.menu.top.export.btn.hide();
                    content.ShareUrl({ invokeType: "addVisualBase", parameter: me.status.signals.shareParameter });
                    break;
            }

            return true;

        } catch (e) { me._writeErr(e); return false; }
    },

    _exportNow: function (me) {
        /// <summary>
        /// exports highcharts data
        ///  https://stackoverflow.com/questions/15623919/asp-net-webrequest-to-highcharts-export-server
        /// </summary>
        try {
            
            var item = me.vcMenu.menu.top.export.menu.find(".button-toggle-active");
            //get the highchart object
            var chart = window.__GLOBAL_VISUAL_LIST[me.globalVisualListKey];

            let content = me.vcMenu.menu.top.export.content;
            let btn = me.vcMenu.menu.top.export.btn;
            var selectedChart = me.status.menu.selectedChart;

            // check if icon chart is opened and overwrite selectedChart to export correct chart
            if (me.settings.currentIconChart.active) { selectedChart = me.settings.currentIconChart.iconChart.id; };

            switch (item.data("type")) {
                case "xls":

                    var param;
                    switch (selectedChart) {
                        case "meterreadings": // export current meterreadings
                            param = { bsaids: me.status.signals.selectedBsaids, startDate: me.status.menu.startDate, DataType: -1, LoggerId: me.specific.LoggerId };

                            me.vcMenu.menu.top.export.content.html(me.vcC.getLoadingIcon());
                            me.vcV.getExportByName("VISUAL2_METERREADINGS_CURRENT", me.options.invoke.vcgid + 1, window.getCurrentTimestamp(), 0, 0, JSON.stringify(param), "", me.settings.deviceType, "xls", function (result) {
                                content.html("<a class='export-file' href='" + result + "' target='_blank'>" + me.specific.resources.export + ".xls</a>");
                            });
                            break;

                        case "ZSTINFO": // export archive meterreadings
                            param = { bsaids: me.status.signals.selectedBsaids, startDate: me.status.menu.startDate, endDate: me.status.menu.endDate, DataType: -1, LoggerId: me.specific.LoggerId };

                            me.vcMenu.menu.top.export.content.html(me.vcC.getLoadingIcon());
                            me.vcV.getExportByName("VISUAL2_METERREADINGSARCH", me.options.invoke.vcgid + 1, window.getCurrentTimestamp(), 0, 0, JSON.stringify(me.settings.currentIconChart.parameter), "", me.settings.deviceType, "xls", function (result) {
                                if (result != "")
                                    content.html("<a class='export-file' href='" + result + "' target='_blank'>" + me.specific.resources.export + ".xls</a>");
                                else
                                    content.html("<b class='icon-color-error'>" + me.specific.resources.errorDuringExport + "</b>");
                            });
                            break;

                        case "onlinelist": // export current meterreadings
                            param = { bsaids: me.status.signals.selectedBsaids, startDate: me.status.menu.startDate, DataType: -1, LoggerId: me.specific.LoggerId };

                            me.vcMenu.menu.top.export.content.html(me.vcC.getLoadingIcon());
                            me.vcV.getExportByName("VISUAL2_VCMENU_ONLINE", me.options.invoke.vcgid + 1, window.getCurrentTimestamp(), 0, 0, JSON.stringify(param), "", me.settings.deviceType, "xls", function (result) {
                                content.html("<a class='export-file' href='" + result + "' target='_blank'>" + me.specific.resources.export + ".xls</a>");
                            });
                            break;


                        case "comparisonlist": // export current meterreadings

                            param = {
                                Bsaids: me.status.signals.allSelectedBsaids,
                                StartDate: me.status.menu.startDate,
                                EndDate: me.status.menu.endDate,
                                Years: parseInt(me.vcMenu.menu.main.specificOptions.find("#specific-option-settings-years").val()),
                                Type: me.options.parameter.type
                            };

                            me.vcMenu.menu.top.export.content.html(me.vcC.getLoadingIcon());
                            me.vcV.getExportByName("VISUAL2_COMPARISON_LIST", me.options.invoke.vcgid + 1, window.getCurrentTimestamp(), 0, 0, JSON.stringify(param), "", me.settings.deviceType, "xls", function (result) {
                                content.html("<a class='export-file' href='" + result + "' target='_blank'>" + me.specific.resources.export + ".xls</a>");
                            });
                            break;



                        default: // export any of the others
                            me.vcMenu.menu.top.export.content.html(me.vcC.getLoadingIcon());
                            me.vcV.getExportByName(me._getRampVisualName(me.status), me.options.invoke.vcgid + 1, window.getCurrentTimestamp(), 0, 0, JSON.stringify(me._getRampParameter(me.status)), JSON.stringify(me._getRampSignalParameter(me.status)), me.settings.deviceType, "xls", function (result) {
                                content.html("<a class='export-file' href='" + result + "' target='_blank'>" + me.specific.resources.export + ".xls</a>");
                            });
                            break;
                    }
                    break;
                case "csv":
                    chart.downloadCSV();
                    content.html(me.specific.resources.findFileInDownloads);
                    btn.hide();
                    break;
                case "jpg":
                    chart.exportChart({ type: 'image/jpeg', filename: me.specific.resources.export });
                    content.html(me.specific.resources.findFileInDownloads);
                    btn.hide();
                    break;
                case "png":
                    chart.exportChart({ type: 'image/png', filename: me.specific.resources.export });
                    content.html(me.specific.resources.findFileInDownloads);
                    btn.hide();
                    break;
                case "pdf":
                    chart.exportChart({ type: 'application/pdf', filename: me.specific.resources.export });
                    content.html(me.specific.resources.findFileInDownloads);
                    btn.hide();
                    break;
            }

        } catch (e) { me._writeErr(e); }
    },

    _enableDisableBtnExport: function (me, enable) {
        /// <summary>
        /// This function enables/disables the export menu button<br/>
        /// Is used from outside of vcMenuTemplate for toggleClass
        /// </summary>
        try {
            me.vcMenu.menu.top.exportBtn.find("#btn-export-menu").toggleClass("inactive", !enable);
            return true;
        } catch (e) { me._writeErr(e); return false; }
    }
};

